import { render, staticRenderFns } from "./privateFiles.vue?vue&type=template&id=b46a88c6&"
import script from "./privateFiles.vue?vue&type=script&lang=js&"
export * from "./privateFiles.vue?vue&type=script&lang=js&"
import style0 from "./privateFiles.vue?vue&type=style&index=0&id=b46a88c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports